import { render } from "./AddTopicEnrollment.vue?vue&type=template&id=22773b8b&scoped=true"
import script from "./AddTopicEnrollment.vue?vue&type=script&lang=js"
export * from "./AddTopicEnrollment.vue?vue&type=script&lang=js"

import "./AddTopicEnrollment.vue?vue&type=style&index=0&id=22773b8b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22773b8b"]])

export default __exports__